"use strict";
const actionTypes = require('../actionTypes');
const api = require('../api');
exports.startListeningToSessions = (user) => (dispatch) => {
    const ref = api.database.listenToSessions(user.uid, (event, taskId, sessionByDateOrSessionId) => {
        switch (event) {
            case 'child_added':
                dispatch(sessionAdded(taskId, sessionByDateOrSessionId));
                return;
            case 'child_changed':
                dispatch(sessionChanged(taskId, sessionByDateOrSessionId));
                return;
            default:
                throw new Error('unknown event emitted by listenToTasks');
        }
    });
    dispatch({
        type: actionTypes.LISTEN_TO_SESSIONS,
        ref,
    });
};
const sessionAdded = (taskId, sessionsByDate) => ({
    type: actionTypes.SESSION_ADDED,
    sessionsByDate,
    taskId,
});
const sessionChanged = (taskId, sessionsByDate) => ({
    type: actionTypes.SESSION_CHANGED,
    sessionsByDate,
    taskId,
});
exports.stopListeningToSessions = () => (dispatch, getState) => {
    const sessionsRef = getState().sessions;
    if (sessionsRef) {
        api.database.stopListeningToSessions(sessionsRef);
        dispatch({ type: actionTypes.STOP_LISTENING_TO_SESSIONS });
    }
};



/** WEBPACK FOOTER **
 ** ./src/actions/sessions.ts
 **/